// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//
import { sectionTitleStyles } from "@guestsupply/App/Widgets/SectionTitle/SectionTitle";
import { fontFamilyValues } from "@guestsupply/XDL/constants";
import CaretRight from "@guestsupply/XDL/Icons/CaretRight";
import { color, createLinkIconStyles, homePageTitleStyle, xScreen } from "@guestsupply/XDL/Utilities";
import { IconWrapper } from "@insite/mobius/Icon";
import { css } from "styled-components";

sectionTitleStyles.wrapper = {
    css: css`
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: flex-end;
        flex-wrap: wrap;
        width: 100%;
        margin-bottom: 20px;
        ${xScreen("lte", 767)} {
            flex-direction: column;
            align-items: flex-start;
            gap: 8px;
        }
        ${({ border }: any) => {
            if (border === "bottom") {
                return css`
                    border-bottom: 1px solid ${color("common.border")};
                    padding-bottom: 15px;
                `;
            }

            if (border === "top") {
                return css`
                    border-top: 1px solid ${color("common.border")};
                    padding-top: 15px;
                `;
            }
        }}
    `,
};
sectionTitleStyles.title = {
    ...homePageTitleStyle,
    css: css`
        ${homePageTitleStyle?.css}
        ${({ fontFamily }: any) => {
            if (fontFamily !== null) {
                if (fontFamily === fontFamilyValues.BODONI) {
                    return css`
                        font-family: ${fontFamily};
                        font-weight: 400;
                    `;
                }
                return css`
                    font-family: ${fontFamily};
                `;
            }
        }}
    `,
};
sectionTitleStyles.link = {
    ...createLinkIconStyles(CaretRight, {
        icon: {
            iconProps: {
                size: 12,
            },
        },
    }),
};
